import { render, staticRenderFns } from "./CollectionInformation.vue?vue&type=template&id=f57c977a&scoped=true&"
import script from "./CollectionInformation.vue?vue&type=script&lang=js&"
export * from "./CollectionInformation.vue?vue&type=script&lang=js&"
import style0 from "./CollectionInformation.vue?vue&type=style&index=0&id=f57c977a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57c977a",
  null
  
)

export default component.exports